'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _params = require('hub-http/helpers/params');

var _OAuthUtils = require('../utils/OAuthUtils');

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('QueryParamsContainer');

var PARAMS = (0, _immutable.Map)({});

var PARAMS_TO_LOWERCASE = ['email', 'website'];

var QueryParamsContainer = {
  getJS: function getJS() {
    return PARAMS.toJS();
  },
  get: function get(key) {
    if (key) {
      return PARAMS.get(key);
    }
    return PARAMS;
  },
  setParam: function setParam(key, value) {
    PARAMS = PARAMS.set(key, value);
  },
  hydrate: function hydrate() {
    var queryString = window.location.search;

    if (queryString.length) {
      var queryParams = (0, _params.parse)(queryString.substring(1));
      queryParams = (0, _immutable.Map)(queryParams);

      PARAMS_TO_LOWERCASE.forEach(function (paramKey) {
        var paramValue = queryParams.get(paramKey);
        if (paramValue) {
          queryParams = queryParams.set(paramKey, String(paramValue).toLowerCase());
        }
      });
      PARAMS = queryParams;
      return;
    }

    // we persist query params on the hash passed from Google OAuth
    try {
      var hash = window.location.hash;
      if (hash) {
        var state = (0, _OAuthUtils.parseState)(hash);
        if (state) {
          var parsedParams = (0, _OAuthUtils.parseParams)(state.params);
          PARAMS = PARAMS.merge(parsedParams);
        }
      }
    } catch (e) {
      LOG.error('Error filling query parameters');
    }
  },
  clear: function clear() {
    PARAMS = PARAMS.clear();
  }
};

exports.default = QueryParamsContainer;
module.exports = exports['default'];